import { put, takeEvery } from "redux-saga/effects";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../../services/httpService";
import messagePopup from "../../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  ALL_STATS_LIST_START: "ALL_STATS_LIST_START",
  ALL_STATS_LIST_FAIL: "ALL_STATS_LIST_FAIL",
  ALL_STATS_LIST_SUCCESS: "ALL_STATS_LIST_SUCCESS",
};

// ============================================ Actions ========================================================
export const allStatsListStart = (data) => ({
  type: actionType.ALL_STATS_LIST_START,
  payload: data,
});

export const allStatsListSuccess = (data) => ({
  type: actionType.ALL_STATS_LIST_SUCCESS,
  payload: data,
});

export const allStatsListFail = (data) => ({
  type: actionType.ALL_STATS_LIST_FAIL,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function allStatsLIstReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.ALL_STATS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.ALL_STATS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    case actionType.ALL_STATS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* allStatsListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(allStatsListSuccess(response.data.data.allStats));
    } else {
      messagePopup("", "Stats List failed", "error");
      yield put(allStatsListFail("Stats List failed"));
    }
  } catch (error) {
    messagePopup("", "Stats list failed", "error");
    yield put(allStatsListFail("Stats List failed"));
  }
}

//Watcher
export function* watchallStatsListSaga() {
  yield takeEvery(actionType.ALL_STATS_LIST_START, allStatsListSaga);
}
